import {PlayerOverviewComponent} from "./pages/player-overview/player-overview.component";
import {PendingPlayersOverviewComponent} from "./pages/pending-players-overview/pending-players-overview.component";

export const connectionRoutes =  [
  {path: 'list', component: PlayerOverviewComponent, pathMatch: 'full'},
  {path: 'pending', component: PendingPlayersOverviewComponent, pathMatch: 'full'},
];
